import { render, staticRenderFns } from "./TenthComponent.vue?vue&type=template&id=f55f5660"
import script from "./TenthComponent.vue?vue&type=script&lang=js"
export * from "./TenthComponent.vue?vue&type=script&lang=js"
import style0 from "./TenthComponent.vue?vue&type=style&index=0&id=f55f5660&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports